import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';

export interface UpdateBookingLinkConfirmationDialogData {
  originalSlug: string;
  newSlug: string;
  confirmationCallback: () => Observable<null>;
}

@Component({
  selector: 'meeting-scheduler-update-booking-link-confirmation-dialog',
  templateUrl: './update-booking-link-confirmation-dialog.component.html',
  styleUrls: ['./update-booking-link-confirmation-dialog.component.scss'],
  standalone: false,
})
export class UpdateBookingLinkConfirmationDialogComponent implements OnDestroy {
  isUpdating = false;
  private readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly ref: MatDialogRef<UpdateBookingLinkConfirmationDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) readonly data: UpdateBookingLinkConfirmationDialogData,
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onNoClick(): void {
    this.ref.close(false);
  }

  onYesClick(): void {
    this.isUpdating = true;
    const sub = this.data.confirmationCallback().subscribe({
      next: () => this.ref.close(true),
    });
    sub.add(() => (this.isUpdating = false));
    this.subscriptions.push(sub);
  }
}
